import { DELETE_CLIENT_BY_REF } from "../constants";
import { getLocalStorage } from "../utils";

export interface DeleteClientByRefRequest {
  docReference: string;
}

export const deleteClientByRef = async (deleteRequest: DeleteClientByRefRequest): Promise<any> => {
  try {
    const deleteClientResponse = await fetch(DELETE_CLIENT_BY_REF, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getLocalStorage("id-token")}`,
      },
      body: JSON.stringify(deleteRequest),
    });
    const deleteResponseContent = await deleteClientResponse.json();

    return deleteResponseContent.data.message === "Success";
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("error", error);
  }

  return false;
};
